import StorefrontReadinessBoard from '../features/storefront-onboarding/components/StorefrontReadinessBoard';

export const StorefrontReadinessPage = () => <StorefrontReadinessBoard />;
